import {Component, OnInit, OnDestroy, HostBinding, HostListener, ElementRef} from '@angular/core';

// Services
import {AppService} from '../../shared/services/app-service';
import {NavigationService} from '../../shared/services/navigation-service';
import {AppCatalogService} from '../shared/services/app-catalog-service';
import {CatalogService} from '../shared/services/catalog-service';
import {CartService} from '../shared/services/cart-service';
import {SceneService} from '../shared/services/scene-service';

// Classes
import {Product} from '../shared/classes/product';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:CatalogPageCmp'));
let Ps = require('perfect-scrollbar');

/**
 * Wrapper component for `productCategories` component from catalog plugin
 * Component with access to the state store.
 * Current configuration has level 1 subcategories rendered as products-grid instead of a category-thumbnail.
 * This configuration creates the effect of a long list of categories with all the products visible.
 */
@Component({
    selector: 'catalog-page-cmp',
    template: require('./catalog.cmp.html'),
    styles: [String(require('./catalog.cmp.scss'))],
    host: { id: 'catalog-host', class: 'catalog-page'},
})
export class CatalogPageCmp {
    
    @HostBinding( 'class.visible' ) _catalogIsVisible: boolean = false;
    @HostBinding( 'class.rendered' ) _catalogIsRendered: boolean = false;
    @HostListener( 'window:resize', ['$event'] ) onResize (event) {
        this._updateCustomScroll();
    }

    private _subscriptions:any = {};
    public catalogElem: any = null;
    private _state: any = {};
    private _imgPaths;
    
    constructor(
        private _appService: AppService,
        private _catalogService: CatalogService,
        private _appCatalogService: AppCatalogService,
        private _navigationService: NavigationService,
        private _elementRef: ElementRef,
        private _cartService: CartService,
        private _sceneService: SceneService
    ) {

        // 'Construct catalog component' );
        this._cacheDomElements();
        this._setupCustomScroll();
        this._imgPaths = this._catalogService.imgPaths;
    }

    
    ngOnInit() {
        // 'Initialise catalog component' );

        let self = this;

        // Open Catalog on init. First  time is blocked due to showing start arrow first.
        this._openCatalog();

        // TODO: Improve
        this._subscriptions.previewVisibilityChanged = this._appService.events.previewVisibilityChanged.subscribe( event => {
            event === false ? self._openCatalog() : self._closeCatalog();
        });
    }

    
    ngOnDestroy() {
        // 'Destruct catalog component' );
    }

    
    private _cacheDomElements () {
        // 'Cache DOM elements' );
        this.catalogElem = this._elementRef.nativeElement;
        debugOff( 'Product categories list element:', this.catalogElem );
    }

    
    private _openCatalog () {
        if (this._catalogIsRendered === true) { return; }
        // 'Open catalog' );
        this._fadeInCatalog();
        // this._uiLayoutService.state.catalogIsOpened = true;
        // this._uiLayoutService.events.catalogOpened.emit('catalogOpened');


        // TODO: Empty scene when catalog is opened. Not via open catalog. Try to decouple
        // Clear all temporary products from scene
        this._sceneService.emptyScene();

    }

    
    private _closeCatalog () {
        // 'Close catalog' );
        if (this._catalogIsRendered === false) { return; }
        this._fadeOutCatalog();
    //     this._uiLayoutService.state.catalogIsOpened = false;
    //     this._uiLayoutService.events.catalogClosed.emit('catalogClosed');

        // TODO: Empty scene when catalog is opened. Not via open catalog. Try to decouple
        // Close all tooltips
        let cartProducts = this._cartService.getCartProducts();
        cartProducts.forEach( (product: Product) => {
            product.hideTooltip();
        });
    }

    
    private _fadeInCatalog() {
        debugOff( 'Fade in catalog' );
        var self = this;
        this._catalogIsRendered = true;
        setTimeout( () => self._catalogIsVisible = true, 0 );
    }

    private _fadeOutCatalog() {
        debugOff( 'Fade out catalog' );
        var self = this;
        this._catalogIsVisible = false;
        setTimeout(() => self._catalogIsRendered = false, 300);
    }

    
    private _setupCustomScroll () {
        debugOff( 'Setup catalog custom scroll' );
        Ps.initialize( this.catalogElem, {
            minScrollbarLength: 30
        });
    }

    
    private _updateCustomScroll () {
        debugOff( 'Update catalog custom scroll' );
        Ps.update( this.catalogElem );
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/pages/catalog.cmp.ts